
// SVG Icon: increase
export default { id: "terriajs-increase" };
export const id = "terriajs-increase";
export const name = "increase";
